// Generated by purs version 0.15.15
import * as DOM_HTML_Indexed_InputType from "../DOM.HTML.Indexed.InputType/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Halogen_HTML_Events from "../Halogen.HTML.Events/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as Halogen_Styled from "../Halogen.Styled/index.js";
import * as Halogen_Styled_DSL from "../Halogen.Styled.DSL/index.js";
import * as Visonum_BulkPingApp_AppHTML from "../Visonum.BulkPingApp.AppHTML/index.js";
import * as Visonum_BulkPingApp_Components_App_Types from "../Visonum.BulkPingApp.Components.App.Types/index.js";
import * as Visonum_BulkPingApp_Imgs from "../Visonum.BulkPingApp.Imgs/index.js";
import * as Visonum_BulkPingApp_Views_PrimaryButton from "../Visonum.BulkPingApp.Views.PrimaryButton/index.js";
import * as Visonum_BulkPingApp_Views_TextInput from "../Visonum.BulkPingApp.Views.TextInput/index.js";
var inline = /* #__PURE__ */ Halogen_Styled_DSL.inline();
var type_ = /* #__PURE__ */ Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var viewPingMethodInput = function (state) {
    var elSynPort = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("SynPort")([ inline({
        gridArea: "SynPort"
    }) ]);
    var elSynCheck = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("SynCheck")([ inline({
        gridArea: "SynCheck"
    }) ]);
    var elSyn = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Syn")([ inline({
        display: "grid",
        gridTemplateColumns: "subgrid",
        gridColumnStart: "SynCheck",
        gridColumnEnd: "SynPort",
        border: "1px solid #ccc",
        borderRadius: "5px",
        alignItems: "center",
        padding: "5px"
    }) ]);
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("PingMethodInput")([ inline({
        display: "grid",
        gridTemplateColumns: "1fr 1fr 2fr",
        gridTemplateRows: "60px",
        gridTemplateAreas: Data_String_Common.joinWith(" ")([ "\"Icmp SynCheck SynPort\"" ]),
        gap: "5px",
        padding: "2px",
        marginTop: "5px"
    }) ]);
    var elLabel = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.label)("Label")([ inline({
        fontSize: "10px",
        fontFamily: "Arial",
        fontWeight: "bold"
    }) ]);
    var elIcmp = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Icmp")([ inline({
        gridArea: "Icmp",
        border: "1px solid #ccc",
        borderRadius: "5px",
        display: "flex",
        alignItems: "start",
        padding: "5px"
    }) ]);
    var elCheckWrapper = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("CheckWrapper")([ inline({
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        padding: "5px"
    }) ]);
    var elCheck = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.input)("Check")([ inline({
        width: "20px",
        height: "20px",
        accentColor: "black"
    }) ]);
    return elRoot([  ])([ elIcmp([  ])([ elCheckWrapper([  ])([ elLabel([  ])([ Halogen_Styled.text("Use ICMP") ]), elCheck([ type_(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.checked(state.newJob.useIcmp), Halogen_HTML_Events.onInput(Data_Function["const"](new Visonum_BulkPingApp_Components_App_Types.UpdateJobInput({
        agentUrl: state.newJob.agentUrl,
        pingCountPerIp: state.newJob.pingCountPerIp,
        intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
        intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
        useSyn: state.newJob.useSyn,
        synPort: state.newJob.synPort,
        destinationIps: state.newJob.destinationIps,
        useIcmp: !state.newJob.useIcmp
    }))) ]) ]) ]), elSyn([  ])([ elSynCheck([  ])([ elCheckWrapper([  ])([ elLabel([  ])([ Halogen_Styled.text("Use TCP SYN") ]), elCheck([ type_(DOM_HTML_Indexed_InputType.InputCheckbox.value), Halogen_HTML_Properties.checked(state.newJob.useSyn), Halogen_HTML_Events.onInput(Data_Function["const"](new Visonum_BulkPingApp_Components_App_Types.UpdateJobInput({
        agentUrl: state.newJob.agentUrl,
        pingCountPerIp: state.newJob.pingCountPerIp,
        intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
        intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
        useIcmp: state.newJob.useIcmp,
        synPort: state.newJob.synPort,
        destinationIps: state.newJob.destinationIps,
        useSyn: !state.newJob.useSyn
    }))) ]) ]) ]), elSynPort([  ])([ (function () {
        if (state.newJob.useSyn) {
            return Visonum_BulkPingApp_Views_TextInput.view({
                multiline: Visonum_BulkPingApp_Views_TextInput.defaultProps.multiline,
                password: Visonum_BulkPingApp_Views_TextInput.defaultProps.password,
                label: "Port",
                value: state.newJob.synPort,
                onChange: function (str) {
                    return new Visonum_BulkPingApp_Components_App_Types.UpdateJobInput({
                        agentUrl: state.newJob.agentUrl,
                        pingCountPerIp: state.newJob.pingCountPerIp,
                        intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                        intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                        useIcmp: state.newJob.useIcmp,
                        useSyn: state.newJob.useSyn,
                        destinationIps: state.newJob.destinationIps,
                        synPort: str
                    });
                },
                onEnter: Data_Maybe.Nothing.value
            });
        };
        return Halogen_Styled.text("");
    })() ]) ]) ]);
};
var view = function (state) {
    var elRoot = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("EditPanel")([ inline({
        display: "grid",
        width: "100%",
        padding: "5px",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "auto auto auto",
        gridTemplateAreas: Data_String_Common.joinWith(" ")([ "\"Header Header\"", "\"LeftPart RightPart\"", "\"BottomPart BottomPart\"" ]),
        outline: (function () {
            if (state.showNewJob) {
                return "2px solid black";
            };
            return "none";
        })()
    }) ]);
    var elRightPart = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("RightPart")([ inline({
        display: "flex",
        flexDirection: "column",
        gridArea: "RightPart",
        margin: "5px"
    }) ]);
    var elLeftPart = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("LeftPart")([ inline({
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        gridArea: "LeftPart",
        margin: "5px"
    }) ]);
    var elHeader = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("Header")([ inline({
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        gridArea: "Header",
        justifyContent: "end",
        margin: "5px"
    }) ]);
    var elCloseButton = Visonum_BulkPingApp_AppHTML.styleLeaf(Halogen_HTML_Elements.img)("DetailsPanelCloseButton")([ inline({
        width: "20px",
        height: "20px",
        cursor: "pointer"
    }) ]);
    var elBottomPart = Visonum_BulkPingApp_AppHTML.styleNode(Halogen_HTML_Elements.div)("BottomPart")([ inline({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        gridArea: "BottomPart",
        justifyContent: "end",
        padding: "5px"
    }) ]);
    return elRoot([  ])(append([ elHeader([  ])([ (function () {
        if (state.showNewJob) {
            return elCloseButton([ Halogen_HTML_Properties.src(Visonum_BulkPingApp_Imgs.imgCross), Halogen_HTML_Events.onClick(Data_Function["const"](new Visonum_BulkPingApp_Components_App_Types.SetShowNewJob(false))) ]);
        };
        return Visonum_BulkPingApp_Views_PrimaryButton.view({
            label: "Add new Job",
            onClick: new Visonum_BulkPingApp_Components_App_Types.SetShowNewJob(true),
            disabled: false
        });
    })() ]) ])((function () {
        var $21 = !state.showNewJob;
        if ($21) {
            return [  ];
        };
        return [ elLeftPart([  ])([ Visonum_BulkPingApp_Views_TextInput.view({
            multiline: Visonum_BulkPingApp_Views_TextInput.defaultProps.multiline,
            password: Visonum_BulkPingApp_Views_TextInput.defaultProps.password,
            label: "Agent URL",
            value: state.newJob.agentUrl,
            onChange: function (str) {
                return new Visonum_BulkPingApp_Components_App_Types.UpdateJobInput({
                    pingCountPerIp: state.newJob.pingCountPerIp,
                    intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                    intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                    useIcmp: state.newJob.useIcmp,
                    useSyn: state.newJob.useSyn,
                    synPort: state.newJob.synPort,
                    destinationIps: state.newJob.destinationIps,
                    agentUrl: str
                });
            },
            onEnter: Data_Maybe.Nothing.value
        }), Visonum_BulkPingApp_Views_TextInput.view({
            multiline: Visonum_BulkPingApp_Views_TextInput.defaultProps.multiline,
            password: Visonum_BulkPingApp_Views_TextInput.defaultProps.password,
            label: "Ping Count per IP",
            value: state.newJob.pingCountPerIp,
            onChange: function (str) {
                return new Visonum_BulkPingApp_Components_App_Types.UpdateJobInput({
                    agentUrl: state.newJob.agentUrl,
                    intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                    intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                    useIcmp: state.newJob.useIcmp,
                    useSyn: state.newJob.useSyn,
                    synPort: state.newJob.synPort,
                    destinationIps: state.newJob.destinationIps,
                    pingCountPerIp: str
                });
            },
            onEnter: Data_Maybe.Nothing.value
        }), Visonum_BulkPingApp_Views_TextInput.view({
            multiline: Visonum_BulkPingApp_Views_TextInput.defaultProps.multiline,
            password: Visonum_BulkPingApp_Views_TextInput.defaultProps.password,
            label: "Interval Between IPs (ms)",
            value: state.newJob.intervalBetweenIpsMillis,
            onChange: function (str) {
                return new Visonum_BulkPingApp_Components_App_Types.UpdateJobInput({
                    agentUrl: state.newJob.agentUrl,
                    pingCountPerIp: state.newJob.pingCountPerIp,
                    intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                    useIcmp: state.newJob.useIcmp,
                    useSyn: state.newJob.useSyn,
                    synPort: state.newJob.synPort,
                    destinationIps: state.newJob.destinationIps,
                    intervalBetweenIpsMillis: str
                });
            },
            onEnter: Data_Maybe.Nothing.value
        }), Visonum_BulkPingApp_Views_TextInput.view({
            multiline: Visonum_BulkPingApp_Views_TextInput.defaultProps.multiline,
            password: Visonum_BulkPingApp_Views_TextInput.defaultProps.password,
            label: "Interval Between Pings (ms)",
            value: state.newJob.intervalBetweenPingsMillis,
            onChange: function (str) {
                return new Visonum_BulkPingApp_Components_App_Types.UpdateJobInput({
                    agentUrl: state.newJob.agentUrl,
                    pingCountPerIp: state.newJob.pingCountPerIp,
                    intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                    useIcmp: state.newJob.useIcmp,
                    useSyn: state.newJob.useSyn,
                    synPort: state.newJob.synPort,
                    destinationIps: state.newJob.destinationIps,
                    intervalBetweenPingsMillis: str
                });
            },
            onEnter: Data_Maybe.Nothing.value
        }), viewPingMethodInput(state) ]), elRightPart([  ])([ Visonum_BulkPingApp_Views_TextInput.view({
            password: Visonum_BulkPingApp_Views_TextInput.defaultProps.password,
            label: "Destination IPs",
            value: state.newJob.destinationIps,
            onChange: function (str) {
                return new Visonum_BulkPingApp_Components_App_Types.UpdateJobInput({
                    agentUrl: state.newJob.agentUrl,
                    pingCountPerIp: state.newJob.pingCountPerIp,
                    intervalBetweenIpsMillis: state.newJob.intervalBetweenIpsMillis,
                    intervalBetweenPingsMillis: state.newJob.intervalBetweenPingsMillis,
                    useIcmp: state.newJob.useIcmp,
                    useSyn: state.newJob.useSyn,
                    synPort: state.newJob.synPort,
                    destinationIps: str
                });
            },
            onEnter: Data_Maybe.Nothing.value,
            multiline: true
        }) ]), elBottomPart([  ])((function () {
            var result = Visonum_BulkPingApp_Components_App_Types.parseInputVals(state.newJob);
            return [ Visonum_BulkPingApp_Views_PrimaryButton.view({
                label: "Submit Job",
                onClick: Visonum_BulkPingApp_Components_App_Types.SubmitNewJob.value,
                disabled: Data_Either.isLeft(result)
            }) ];
        })()) ];
    })()));
};
export {
    view
};
//# sourceMappingURL=index.js.map
